export const siteSettings = {
  name: "Sphere Finex",
  link: "https://spherefinex.com",
  email: "support@spherefinex.com",
  appLink: "https://app.spherefinex.com",
};
